import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mic, Users, Presentation } from "lucide-react";

const SpeakingSection = () => {
  const keynotes = [
    {
      title: "The Ownership Mindset",
      desc: "Why traditional real estate limits the individual and the firm, and why most founders build cages instead of companies.",
    },
    {
      title: "Freedom Is a System",
      desc: "Dismantling the \"grind\" to build an infrastructure that passes the \"Hawaii Test\"—it runs whether you show up or not.",
    },
    {
      title: "AI-Driven Infrastructure",
      desc: "Using artificial intelligence to replace admin, automate client acquisition, and build a firm that out-thinks the competition.",
    },
    {
      title: "The Command Code",
      desc: "Leading without apology, setting boundaries, and building the authority that drives high-ticket conversions.",
    },
  ];

  const formats = [
    { icon: Mic, title: "High-Impact Keynotes", desc: "High-energy sessions designed to shift paradigms and spark immediate action." },
    { icon: Users, title: "Strategic Panels", desc: "Industry discussions with real-world depth and architectural insight." },
    { icon: Presentation, title: "Intensive Workshops", desc: "Hands-on sessions that deliver measurable, scalable results for your team." },
  ];

  return (
    <section id="speaking" className="py-20 md:py-32 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center space-y-4 mb-16">
            <span className="text-accent font-semibold uppercase tracking-widest text-sm">
              Thought Leadership
            </span>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight text-secondary-foreground">
              Speaking &{" "}
              <span className="text-accent">Keynotes</span>
            </h2>
            <p className="text-lg text-secondary-foreground/70 leading-relaxed max-w-2xl mx-auto">
              Marquetta speaks on founder psychology, commanding authority, and why the most successful people are still broke on paper.
            </p>
          </div>

          {/* Signature Keynotes */}
          <div className="mb-16">
            <h3 className="text-accent font-semibold uppercase tracking-widest text-sm mb-8 text-center">
              Featured Signature Keynotes
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {keynotes.map((keynote, index) => (
                <div key={index} className="border border-accent/20 rounded-xl p-6 bg-secondary-foreground/5">
                  <h4 className="font-bold text-secondary-foreground text-lg mb-2">{keynote.title}</h4>
                  <p className="text-secondary-foreground/60 text-sm leading-relaxed">{keynote.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Engagement Formats */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {formats.map((format, index) => (
              <div key={index} className="text-center p-6 border border-accent/20 rounded-xl bg-secondary-foreground/5">
                <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center mx-auto mb-4">
                  <format.icon className="w-6 h-6 text-accent" />
                </div>
                <h4 className="font-bold text-secondary-foreground mb-2">{format.title}</h4>
                <p className="text-secondary-foreground/60 text-sm">{format.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center space-y-4">
            <Link to="/speaking">
              <Button size="lg" variant="premium" className="group">
                Book Marquetta to Speak
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <div className="pt-4">
              <Link to="/academy" className="inline-flex items-center gap-2 text-accent hover:text-accent/80 font-semibold transition-colors">
                Ready to Master the System? Visit the Academy for Advanced Training
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakingSection;
